import 'pages/products/parameters/parameters-list-select-modal.tag'
riot.tag2('modification-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/modifications"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;products&quot;, &quot;0100&quot;) : checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.name || \'Добавление модификации\' : item.name || \'Редактирование модификации\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="row">\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.name}">\n            <label class="control-label">Наименование</label>\n            <input class="form-control" name="name" value="{item.name}">\n            <div class="help-block">{error.name}</div>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <div class="form-group {has-error: error.type}">\n            <label class="control-label">Тип цены</label>\n            <select class="form-control" name="vtype" value="{item.vtype}">\n              <option value="0">Добавляет к цене</option>\n              <option value="1">Умножает на цену</option>\n              <option value="2">Замещает цену</option>\n            </select>\n            <div class="help-block">{error.vtype}</div>\n          </div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-md-12">\n          <catalog-static name="values" add="{addColumns}" cols="{columnsCols}" rows="{item.values}" remove="true">\n            <yield to="body">\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n          <div class="alert alert-danger" if="{error.values}">{error.values}</div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.item = {};
self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.rules = {
    name: 'empty',
    values: {
        required: true,
        rules: [{
            vtype: 'minLength[1]',
            prompt: 'В списке должно быть не менее одного элемента'
        }]
    }
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

// o_O
self.columnsCols = [{ name: 'name', value: 'Наименование' }];

self.addColumns = function () {
    var _this = this;
    modals.create('parameters-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        filters: { field: 'type', sign: 'IN', value: 'list, colorlist' },
        submit: function submit() {
            _this.value = _this.value || [];

            var items = this.tags.catalog.tags.datatable.getSelectedRows();
            var ids = _this.value.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) _this.value.push(item);
            });

            self.update();
            this.modalHide();

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.tags.values.root.dispatchEvent(event);
        }
    });
};

self.submit = function (e) {
    var params = self.item;
    self.error = self.validation.validate(self.item, self.rules);
    if (!self.error) {
        API.request({
            object: 'Modification',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.item = response;
                self.update();
                popups.create({ title: 'Успех!', text: 'Модификация сохранена!', style: 'popup-success' });
                if (self.isNew) riot.route('products/modifications/' + response.id);
                observable.trigger('modifications-reload');
            }
        });
    }
};

self.reload = function () {
    observable.trigger('modifications-edit', self.item.id);
};

observable.on('modifications-new', function () {
    self.error = false;
    self.isNew = true;
    self.item = { values: [] };
    self.update();
});

observable.on('modifications-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.loader = true;
    self.isNew = false;
    self.item = {};

    API.request({
        object: 'Modification',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.item = response;
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.update({
                loader: false
            });
        }
    });
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/products/modifications/modification-edit.tag